export const NAME = 'audioInput' as const;

export const INPUT_SAMPLE_RATE = 16000;
